import React from "react"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import HistoryList from "./HistoryList"
import "./HistoryListModal.css"

function HistoryListModal({ isOpen, toggle, title = "History", objectIds = [], pageSize = 10, emptyText = "No history found yet.", }) {
    const normalizedObjectIds = (objectIds || []).filter(Boolean)
    const closeButton = (
        <button type="button" className="history-list-modal__close" onClick={toggle} aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    )

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg" centered className="history-list-modal">
            <ModalHeader toggle={toggle} close={closeButton}>{title}</ModalHeader>
            <ModalBody className="history-list-modal__body">
                <div className="history-list-modal__intro">
                    <div className="history-list-modal__intro-icon">
                        <i className="fa fa-history" aria-hidden="true" />
                    </div>
                    <div>
                        <div className="history-list-modal__intro-title">Activity Timeline</div>
                        <div className="history-list-modal__intro-text">
                            Review the recorded changes for this item.
                        </div>
                    </div>
                </div>

                <div className="history-list-modal__content">
                    <HistoryList
                        objectIds={normalizedObjectIds}
                        pageSize={pageSize}
                        emptyText={emptyText}
                    />
                </div>
            </ModalBody>
        </Modal>
    )
}

export default HistoryListModal
